import { AbstractControl, ValidationErrors } from '@angular/forms';

export function emailValidator(
  FormControl: AbstractControl<any>
): ValidationErrors | null {
  const { value } = FormControl;

  if (
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~()](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~()])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(
      value
    )
  ) {
    return null;
  } else {
    return { emailPattern: true };
  }
}
